import React, { FC } from 'react';

import Loader from 'components/common/ui-kit/Loader';
import Consent from 'components/statements/Consent';
import Informing from 'components/statements/Informing';
import useAppSelector from 'hooks/common/useAppSelector';
import { EducationBasis } from 'models/staff/upload-queue';
import { useGetApplicationAgreementsQuery } from 'redux/api/applications/applications-api';
import { contractApi } from 'redux/api/applications/contract-api';
import { selectApplication } from 'redux/selectors/enrollee/application';

import { ApplicationEducationLevel } from '../../../models/applications/enum';

const InformingAndAgreementsPage: FC = () => {
  const application = useAppSelector(selectApplication);
  const { data: contracts } = contractApi.useGetByApplicationIdQuery(
    // @ts-expect-error it's okay
    application?.id,
    {
      skip: !application?.id,
    }
  );

  const { data: agreements } = useGetApplicationAgreementsQuery(
    // @ts-expect-error it's okay
    application?.id,
    {
      skip: !application?.id,
    }
  );

  if (!contracts || !application || !agreements) {
    return <Loader />;
  }

  const today = new Date().getTime();

  const isConsentDisabled =
    application.educationBasis !== EducationBasis.BUDGET;

  const isInformingDisabled =
    application.educationBasis !== EducationBasis.CONTRACT ||
    today < new Date('2025-08-08T00:00:00+03:00').getTime() ||
    today >= new Date('2025-08-20T12:00:00+03:00').getTime();

  return (
    <div style={{ display: 'flex', gap: 20, flexDirection: 'column' }}>
      <Consent
        hasConcent={agreements[0]?.isAgreed ?? false}
        disabled={isConsentDisabled}
      />
      <div>
        {application.educationLevel !== ApplicationEducationLevel.SECONDARY && (
          <Informing disabled={isInformingDisabled} />
        )}
      </div>
    </div>
  );
};

export default InformingAndAgreementsPage;
